// Декодирует payload JWT без проверки подписи — нужен только exp.
// Подпись проверяет бэкенд; здесь мы лишь избегаем заведомо бесполезных
// запросов с протухшим токеном.
export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(
      atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
    );
    if (!payload.exp) return false;
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};
